<script setup>
import { getCurrentInstance, onMounted, onUnmounted, ref } from "vue";

const { appContext } = getCurrentInstance();
const { $endpoint, $axios } = appContext.config.globalProperties;

const ribbonData = ref([]);           // Use ref for arrays
const ribbonAnimeStep = ref(0);       // Use ref for primitives
let intervalId = null;

async function loadRibbon() {
  try {
    const resp = await $axios.get($endpoint.LoadRibbon);
    ribbonData.value = resp.data?.news ?? [];
  } catch (error) {
    console.error("Failed to load ribbon data:", error);
  }
}

onMounted(() => {
  loadRibbon();

  intervalId = setInterval(() => {
    if (!ribbonData.value.length) return;

    // ✅ Update the *value*, not the variable
    ribbonAnimeStep.value =
        (ribbonAnimeStep.value + 1) % ribbonData.value.length;
  }, 15000);
});

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
});
</script>

<template>
  <div class="uk-width-auto uk-position-relative">
    <div class="ribbon" v-if="ribbonData.length">
      <i>
        <span>
          <s></s>
          {{ ribbonData[ribbonAnimeStep]?.title }}
          <span>{{ ribbonData[ribbonAnimeStep]?.description }}</span>
          <s></s>
        </span>
      </i>
    </div>
  </div>
</template>

<style scoped>
/* Add your ribbon styles here */
</style>
